import React, { useState, useEffect, useCallback, useRef } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { colors, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const DURUM = {
  saglikli: { ad: 'sağlıklı', renk: colors.successText, zemin: colors.successLight },
  bozuk: { ad: 'bozuk', renk: colors.warningText, zemin: colors.warningLight },
  kayip: { ad: 'kayıp', renk: colors.dangerText, zemin: colors.dangerLight },
  bos: { ad: 'boş', renk: colors.dangerText, zemin: colors.dangerLight },
  kaynaksiz: { ad: 'kaynak yok', renk: colors.textSecondary, zemin: colors.bgPage },
}

const SUZGEC = [
  { k: '', ad: 'Sorunlular' },
  { k: 'kayip', ad: 'Kayıp' },
  { k: 'bozuk', ad: 'Bozuk' },
  { k: 'bos', ad: 'Boş' },
  { k: 'kaynaksiz', ad: 'Kaynak yok' },
  { k: 'saglikli', ad: 'Sağlıklı' },
]

function Rozet({ durum }) {
  const d = DURUM[durum] || DURUM.kaynaksiz
  return (
    <span style={{
      ...ui.chip, background: d.zemin, color: d.renk, border: '1px solid ' + d.zemin,
      fontWeight: 600, whiteSpace: 'nowrap',
    }}>{d.ad}</span>
  )
}

function Sayi({ etiket, deger, alt, vurgu }) {
  return (
    <div style={ui.statBox}>
      <p style={ui.statLabel}>{etiket}</p>
      <p style={{ ...ui.statValue, color: vurgu || colors.textPrimary }}>{deger}</p>
      {alt && <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '4px 0 0' }}>{alt}</p>}
    </div>
  )
}

export default function SmartContentDenetim() {
  const { selectedBrand } = useBrand()
  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }
  const brandId = selectedBrand && selectedBrand.id

  const [ozet, setOzet] = useState(null)
  const [kayitlar, setKayitlar] = useState([])
  const [suzgec, setSuzgec] = useState('')
  const [yukleniyor, setYukleniyor] = useState(false)
  const [busy, setBusy] = useState(false)
  const [msg, setMsg] = useState(null)
  const [acik, setAcik] = useState('')
  const zamanlayici = useRef(null)

  const flash = useCallback((text, ok = true) => {
    setMsg({ text, ok })
    setTimeout(() => setMsg(null), 5000)
  }, [])

  const hataMetni = e => (e.response && e.response.data && e.response.data.error) || e.message

  const ozetYukle = useCallback((sessiz) => {
    if (!brandId) return
    axios.get(`${API}/admin/brands/${brandId}/smart-content/denetim`, { headers })
      .then(r => setOzet(r.data))
      .catch(e => { if (!sessiz) flash(hataMetni(e), false) })
  }, [brandId]) // eslint-disable-line

  const listeYukle = useCallback((durum) => {
    if (!brandId) return
    setYukleniyor(true)
    const par = { limit: 400 }
    if (durum) par.durum = durum
    axios.get(`${API}/admin/brands/${brandId}/smart-content/denetim/liste`, { headers, params: par })
      .then(r => setKayitlar(r.data.kayitlar || []))
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setYukleniyor(false))
  }, [brandId]) // eslint-disable-line

  useEffect(() => {
    setOzet(null); setKayitlar([]); setSuzgec(''); setAcik('')
    if (!brandId) return
    ozetYukle()
    listeYukle('')
  }, [brandId]) // eslint-disable-line

  const kosuyor = !!(ozet && ozet.son && !ozet.son.bitti && !ozet.son.hata)

  useEffect(() => {
    if (zamanlayici.current) { clearInterval(zamanlayici.current); zamanlayici.current = null }
    if (kosuyor) {
      zamanlayici.current = setInterval(() => ozetYukle(true), 4000)
    }
    return () => { if (zamanlayici.current) clearInterval(zamanlayici.current) }
  }, [kosuyor]) // eslint-disable-line

  useEffect(() => {
    if (!kosuyor && ozet && ozet.son && ozet.son.bitti) listeYukle(suzgec)
  }, [kosuyor]) // eslint-disable-line

  function calistir() {
    if (!window.confirm('Denetim başlatılacak. Bu işlem hiçbir şeyi değiştirmez, yalnızca ürünleri kontrol edip rapor üretir. Devam edilsin mi?')) return
    setBusy(true)
    axios.post(`${API}/admin/brands/${brandId}/smart-content/denetim/calistir`, {}, { headers })
      .then(() => { flash('Denetim başladı, birkaç dakika sürebilir'); setTimeout(() => ozetYukle(true), 1500) })
      .catch(e => flash(hataMetni(e), false))
      .finally(() => setBusy(false))
  }

  function suzgecDegistir(k) {
    setSuzgec(k)
    setAcik('')
    listeYukle(k)
  }

  if (!selectedBrand) return <div style={ui.notice}>Önce bir marka seçin.</div>

  const son = ozet && ozet.son
  const gosterilen = suzgec
    ? kayitlar
    : kayitlar.filter(x => x.durum !== 'saglikli' || x.gorsel_kirik > 0)

  const yuzde = son && son.denetlenen ? Math.round((son.saglikli / son.denetlenen) * 100) : 0

  return (
    <div>
      {msg && <div style={{ ...(msg.ok ? s.alertSuccess : s.alertDanger), marginBottom: '16px' }}>{msg.text}</div>}

      <div style={{ ...ui.notice, marginBottom: '16px' }}>
        Denetim her gün <b>06:45</b>'te kendiliğinden çalışır ve ürün açıklamalarının bozulup bozulmadığını kontrol eder.
        <b> Hiçbir şey değiştirmez</b>, yalnızca rapor üretir. Bulunan sorunları düzeltmek ayrı bir adımdır.
      </div>

      <div style={{ ...s.card, marginBottom: '16px' }}>
        <div style={{ ...s.flexBetween, marginBottom: son ? '14px' : 0, flexWrap: 'wrap', gap: '10px' }}>
          <div>
            <h3 style={{ ...s.sectionTitle, margin: 0 }}>Son denetim</h3>
            <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '2px 0 0' }}>
              {son
                ? (son.bitti
                  ? new Date(son.basladi).toLocaleString('tr-TR') + ' · ' + (son.sure_sn || 0) + ' saniye sürdü'
                  : 'şu anda çalışıyor…')
                : 'bu markada henüz denetim yapılmadı'}
            </p>
          </div>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
            {kosuyor && <span style={{ ...s.badgeWarning, fontSize: '11.5px' }}>çalışıyor</span>}
            <button style={ui.btnQuiet} onClick={() => { ozetYukle(); listeYukle(suzgec) }}>Yenile</button>
            <button style={s.btnSecondary} onClick={calistir} disabled={busy || kosuyor}>Şimdi denetle</button>
          </div>
        </div>

        {son && son.hata && (
          <div style={{ ...s.alertDanger, marginBottom: '12px' }}>Denetim hata verdi: {son.hata}</div>
        )}

        {son && son.bitti && (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '12px', marginBottom: '14px' }}>
              <Sayi etiket="Denetlenen ürün" deger={son.denetlenen} />
              <Sayi etiket="Sağlıklı" deger={son.saglikli} alt={'%' + yuzde} vurgu={colors.successText} />
              <Sayi etiket="Bozuk" deger={son.bozuk} vurgu={son.bozuk ? colors.warningText : undefined} />
              <Sayi etiket="Kayıp" deger={son.kayip} vurgu={son.kayip ? colors.dangerText : undefined} />
              <Sayi etiket="Kırık görselli" deger={son.gorsel_kirik_urun} vurgu={son.gorsel_kirik_urun ? colors.warningText : undefined} />
              <Sayi etiket="SSS kaybı" deger={son.geo_kayip} vurgu={son.geo_kayip ? colors.dangerText : undefined} alt={son.geo_urun + ' üründe SSS var'} />
            </div>
            <div style={ui.meter}><div style={ui.meterFill(yuzde)} /></div>
            <p style={{ fontSize: '11.5px', color: colors.textMuted, margin: '8px 0 0' }}>
              {son.bos > 0 && son.bos + ' ürünün açıklaması boş · '}
              {son.kaynaksiz > 0 && son.kaynaksiz + ' üründe hazır içerik yok · '}
              bu koşuda {son.gorsel_bakilan} görsel adresi kontrol edildi
            </p>
          </>
        )}
      </div>

      {son && son.bitti && (
        <div style={{ ...s.card, marginBottom: '16px' }}>
          <div style={{ ...s.flexBetween, marginBottom: '12px', flexWrap: 'wrap', gap: '10px' }}>
            <h3 style={{ ...s.sectionTitle, margin: 0 }}>Ürünler</h3>
            <div className="sx-wrap" style={{ ...ui.segmented, maxWidth: '100%' }}>
              {SUZGEC.map(x => (
                <button key={x.k} style={ui.segmentedBtn(suzgec === x.k)} onClick={() => suzgecDegistir(x.k)}>{x.ad}</button>
              ))}
            </div>
          </div>

          {yukleniyor && <p style={ui.emptyText}>Yükleniyor…</p>}

          {!yukleniyor && gosterilen.length === 0 && (
            <p style={ui.emptyText}>
              {suzgec ? 'Bu durumda ürün yok.' : 'Hiçbir üründe sorun bulunamadı.'}
            </p>
          )}

          {!yukleniyor && gosterilen.map(k => {
            const ac = acik === k.product_id
            const kirik = k.kirik_adresler || []
            return (
              <div key={k.product_id} style={{ ...s.cardFlat, padding: '11px 14px', marginBottom: '8px' }}>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                  <Rozet durum={k.durum} />
                  <div style={{ flex: '1 1 220px', minWidth: 0 }}>
                    <div style={{ fontSize: '13px', fontWeight: 600, color: colors.textPrimary, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {k.product_name || k.product_id}
                    </div>
                    <div style={{ fontSize: '11.5px', color: colors.textMuted, marginTop: '2px' }}>
                      {k.product_code ? k.product_code + ' · ' : ''}{k.sebep || 'sorun yok'}
                    </div>
                  </div>
                  {k.gorsel_kirik > 0 && (
                    <span style={{ ...s.badgeWarning, fontSize: '11px' }}>{k.gorsel_kirik}/{k.gorsel_toplam} görsel kırık</span>
                  )}
                  {k.geo_var && (
                    <span style={k.geo_korundu === false ? { ...s.badgeWarning, fontSize: '11px' } : ui.chip}>
                      {k.geo_korundu === false ? 'SSS kayboldu' : 'SSS korunuyor'}
                    </span>
                  )}
                  {(kirik.length > 0 || k.durum !== 'saglikli') && (
                    <button style={ui.btnSm} onClick={() => setAcik(ac ? '' : k.product_id)}>{ac ? 'Kapat' : 'Ayrıntı'}</button>
                  )}
                </div>

                {ac && (
                  <div style={{ marginTop: '10px', borderTop: `1px solid ${colors.borderLight}`, paddingTop: '10px', fontSize: '12px', color: colors.textSecondary }}>
                    <div style={{ display: 'flex', gap: '18px', flexWrap: 'wrap', marginBottom: kirik.length ? '10px' : 0 }}>
                      <span>canlı açıklama: <b style={{ fontVariantNumeric: 'tabular-nums' }}>{k.canli_uzunluk}</b> karakter</span>
                      {k.beklenen_uzunluk != null && <span>hazır içerik: <b style={{ fontVariantNumeric: 'tabular-nums' }}>{k.beklenen_uzunluk}</b> karakter</span>}
                      <span>tasarım bloğu: {k.kok_blok === null ? '—' : (k.kok_blok ? 'var' : 'YOK')}</span>
                      {k.stil_ok !== null && <span>stil: {k.stil_ok ? 'sağlam' : 'BOZUK'}</span>}
                    </div>
                    {kirik.length > 0 && (
                      <div>
                        <div style={{ fontWeight: 600, marginBottom: '4px', color: colors.textPrimary }}>Açılmayan görseller</div>
                        {kirik.map((u, i) => (
                          <div key={i} style={{ fontSize: '11.5px', color: colors.textMuted, wordBreak: 'break-all', marginBottom: '2px' }}>{u}</div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}

      {ozet && ozet.gecmis && ozet.gecmis.length > 1 && (
        <div style={s.card}>
          <h3 style={{ ...s.sectionTitle, marginBottom: '12px' }}>Geçmiş denetimler</h3>
          {ozet.gecmis.map(g => (
            <div key={g.id} style={{
              display: 'flex', gap: '14px', flexWrap: 'wrap', alignItems: 'center',
              padding: '8px 0', borderBottom: `1px solid ${colors.borderLight}`, fontSize: '12.5px',
            }}>
              <span style={{ color: colors.textMuted, minWidth: '132px' }}>{new Date(g.basladi).toLocaleString('tr-TR')}</span>
              <span style={{ color: colors.textSecondary }}>{g.denetlenen} ürün</span>
              <span style={{ color: colors.successText }}>{g.saglikli} sağlıklı</span>
              {g.bozuk > 0 && <span style={{ color: colors.warningText }}>{g.bozuk} bozuk</span>}
              {g.kayip > 0 && <span style={{ color: colors.dangerText }}>{g.kayip} kayıp</span>}
              {g.gorsel_kirik_urun > 0 && <span style={{ color: colors.textSecondary }}>{g.gorsel_kirik_urun} kırık görsel</span>}
              {g.hata && <span style={{ color: colors.dangerText }}>hata</span>}
              <span style={{ color: colors.textMuted, marginLeft: 'auto' }}>{g.sure_sn || 0} sn</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
